import { DefaultTheme } from 'styled-components'

export const UPLOAD_FILE_TOAST_CLASS = 'toast-message'

export const getUploadFileToastStyle = (theme: DefaultTheme) => ({
  alignItems: 'center',
  boxSizing: 'border-box' as const,
  overflow: 'hidden',
  borderRadius: `${theme.borderRadius.md}rem`,
  background: theme.colors.menuBg,
  color: theme.colors.neutralWhite
})

export const getUploadFileToastOptions = (theme: DefaultTheme) => ({
  className: UPLOAD_FILE_TOAST_CLASS,
  style: getUploadFileToastStyle(theme)
})
